import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle, XCircle } from "lucide-react";
const ImportSuccessDialog = ({ isOpen, onClose, imported = 0, failed = 0, total = 0 }) => {
  const successPercentage = total > 0 ? Math.round((imported / total) * 100) : 0;
  const failurePercentage = total > 0 ? Math.round((failed / total) * 100) : 0;
  const hasFailures = failed > 0;

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className={hasFailures ? "text-orange-600" : "text-green-600"}>
            {hasFailures ? "Import Completed with Issues" : "Import Successful"}
          </DialogTitle>
        </DialogHeader>
        <div className="py-4 space-y-4">
          <div className="flex items-center justify-center">
            {hasFailures ? (
              <XCircle className="w-12 h-12 text-orange-600" />
            ) : (
              <CheckCircle className="w-12 h-12 text-green-600" />
            )}
          </div>
          
          <div className="text-center space-y-2">
            <p className="text-gray-700 font-medium">
              Import process completed!
            </p>
            {total > 0 && (
              <p className="text-sm text-gray-500">
                Total records processed: {total}
              </p>
            )}
          </div>

          <div className="grid grid-cols-2 gap-4 pt-2 border-t">
            <div className="space-y-1 text-center">
              <div className="flex items-center justify-center gap-2">
                <CheckCircle className="w-5 h-5 text-green-600" />
                <p className="text-xs text-gray-500">Successful</p>
              </div>
              <p className="text-2xl font-bold text-green-600">{imported}</p>
              {total > 0 && (
                <p className="text-xs text-gray-400">{successPercentage}%</p>
              )}
            </div>
            <div className="space-y-1 text-center">
              <div className="flex items-center justify-center gap-2">
                <XCircle className="w-5 h-5 text-red-600" />
                <p className="text-xs text-gray-500">Failed</p>
              </div>
              <p className="text-2xl font-bold text-red-600">{failed}</p>
              {total > 0 && (
                <p className="text-xs text-gray-400">{failurePercentage}%</p>
              )}
            </div>
          </div>
        </div>
        <DialogFooter>
          <Button onClick={onClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ImportSuccessDialog;